import React from "react";
import { HarvestProduct } from "../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { useMediaQuery } from "../hooks/useMediaQuery";
type MobileInventoryLayoutProps = {
  item: HarvestProduct;
  onOpenEdit: (state: boolean, id: string) => void;
  onOpenWarning: (id: string) => void;
};
const MobileInventoryLayout = ({
  item,
  onOpenEdit,
  onOpenWarning,
}: MobileInventoryLayoutProps) => {
  const { name, id, price, discount } = item;
  const isMobile = useMediaQuery("(max-width: 550px)");
  const discountedDisplay = (
    <p>
      <span className="sales-tag">{discount} kr</span>
    </p>
  );

  return (
    <li
      className="inventory-item-wrapper inventory-item-wrapper-small mobile"
      onClick={isMobile ? () => onOpenEdit(true, id) : undefined}
    >
      <div className="inventory-item info-card">
        <div className="inventory-item-texts">
          <p className="inventory-item-header">
            <span className="bold-capitalized item-header">{name}</span>
          </p>
          {discount ? (
            discountedDisplay
          ) : (
            <div className="price-and-discount">
              <p>
                Price: <span className="bold">{price}kr</span>
              </p>{" "}
            </div>
          )}{" "}
          {!isMobile && (
            <button
              className="btn"
              title="Edit"
              onClick={() => onOpenEdit(true, id)}
            >
              <FontAwesomeIcon icon={faPen} style={{ color: "#ffffff" }} />
            </button>
          )}
        </div>
      </div>
    </li>
  );
};

export default MobileInventoryLayout;
